import { Role } from '@kanbu/schema/enums';
import { useLingui } from '@lingui/react/macro';
import { createFileRoute } from '@tanstack/react-router';
import { Button, toast } from '@utima/ui';
import { useState } from 'react';

import { FormPage } from '@/components/page/FormPage';
import { AppSettings } from '@/constants/AppSettings';
import { ChatForm } from '@/features/chats/components/ChatForm';
import { copyToClipboard } from '@/lib/copyToClipboard';
import { trpc } from '@/services/trpc';

const populate = [
  'documentsCount',
  'embeddingsCount',
  'voiceConfig',
  'omnichannelConfig',
];

export const Route = createFileRoute('/_baseLayout/chats/$chatId/edit')({
  component: ChatsEditPage,
  beforeLoad: async ({ context: { accessGuard } }) =>
    accessGuard([Role.SuperAdmin, Role.Admin]),
  loader: async ({ context: { trpcUtils }, params: { chatId } }) =>
    trpcUtils.chats.findOne.ensureData({ id: chatId, populate }),
});

export function ChatsEditPage() {
  const { chatId } = Route.useParams();
  const [actionsTarget, setActionsTarget] = useState<HTMLDivElement | null>(
    null,
  );
  const { t } = useLingui();
  const [data] = trpc.chats.findOne.useSuspenseQuery({
    id: chatId,
    populate,
  });

  return (
    <FormPage
      title={`${t`Configuration`} - ${data.name}`}
      actions={
        <>
          <Button
            data-cta='admin-chats-edit-share-button'
            onClick={() => {
              copyToClipboard(`${AppSettings.playgroundUrl}/${chatId}`).then(
                () => {
                  toast.success(t`Copy link`, {
                    description: t`Link was copied to clipboard`,
                  });
                },
              );
            }}
          >
            {t`Share`}
          </Button>
          <div ref={setActionsTarget} />
        </>
      }
      breadcrumbs={[
        { label: t`Agent` },
        {
          label: data.name,
          to: '/chats/$chatId/edit',
          params: { chatId },
        },
      ]}
    >
      <ChatForm data={data} actionsTarget={actionsTarget} />
    </FormPage>
  );
}
